import { createAction, props } from '@ngrx/store';
import {
	BetragsKorrekturWert,
	ChangeEntryResource,
	LaufendeNummerKorrekturWert,
	TeilloeschenWert,
} from '@schir-int-client/register-change';
import { PartiellRoetungsBereich } from './register.model';

const PREFIX = '[Registerblatt] ';

export const roeteRegisterblattEntryAction = createAction(
	PREFIX + 'Roete Registerblatt Entry',
	props<{
		changeEntry: ChangeEntryResource;
	}>()
);

export const roeteRegisterblattEntryPartiellAction = createAction(
	PREFIX + 'Roete Registerblatt Entry Partiell',
	props<{
		changeEntry: ChangeEntryResource;
		roetungsBereich: PartiellRoetungsBereich;
	}>()
);

export const createTeilloeschenRegisterblattEntryAction = createAction(
	PREFIX + 'Create Teilloeschen Registerblatt Entry',
	props<{
		changeEntry: ChangeEntryResource;
		teilloeschenWert: TeilloeschenWert;
	}>()
);

export const createLaufendeNummerKorrekturAction = createAction(
	PREFIX + 'Create Laufende Nummer Korrektur',
	props<{
		changeEntry: ChangeEntryResource;
		laufendeNummerKorrekturWert: LaufendeNummerKorrekturWert;
	}>()
);

export const createBetragsKorrekturAction = createAction(
	PREFIX + 'Create Betrags Korrektur',
	props<{
		changeEntry: ChangeEntryResource;
		betragsKorrekturWert: BetragsKorrekturWert;
	}>()
);
